// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"faaf2794","225":"bb0b2ecf","287":"6a3684e7","308":"12298832","311":"33207dde","330":"e053eb63","395":"7b1e2776","424":"90a509b2","511":"ddada294","527":"db1bad91","722":"f2f43dab","823":"efb44c30","865":"7193b299","928":"1ff3dd1a","942":"a3f1404a"}[chunkId] + ".chunk.js";
};